import HelpCenter from '../Assets/MarketIcons/HelpCenter.svg';
import Orders from '../Assets/MarketIcons/Orders.svg';
import SaleItem from '../Assets/MarketIcons/SaleItem.svg';
import TrackShipping from '../Assets/MarketIcons/TrackShipping.svg';
import RequestWine from '../Assets/MarketIcons/RequestWine.svg';
import MyBid from '../Assets/MarketIcons/MyBid.svg';
import WatchList from '../Assets/MarketIcons/WatchList.svg';
import BidReminder from '../Assets/MarketIcons/BidReminder.svg';
import All from '../Assets/MarketIcons/All.svg';
import White from '../Assets/MarketIcons/White.svg';
import Red from '../Assets/MarketIcons/Red.svg';
import Rose from '../Assets/MarketIcons/Rose.svg';
import Sparkling from '../Assets/MarketIcons/Sparkling.svg';
import Dessert from '../Assets/MarketIcons/Dessert.svg';
import Cheapest from '../Assets/MarketIcons/Cheapest.svg';
import Expensive from '../Assets/MarketIcons/Expensive.svg';
import Vintage from '../Assets/MarketIcons/Vintage.svg';
import ABV from '../Assets/MarketIcons/ABV.svg';
import Variety from '../Assets/MarketIcons/Variety.svg';
import Auction from '../Assets/MarketIcons/Auction.svg';
import People from '../Assets/MarketIcons/People.svg';
import PeopleRed from '../Assets/MarketIcons/PeopleRed.svg';

const MarketIcons = {
  HelpCenter,
  Orders,
  SaleItem,
  TrackShipping,
  RequestWine,
  MyBid,
  WatchList,
  BidReminder,
  All,
  White,
  Red,
  Rose,
  Sparkling,
  Dessert,
  Cheapest,
  Expensive,
  Vintage,
  ABV,
  Variety,
  Auction,
  People,
  PeopleRed,
};

export default MarketIcons;
